let backendHost;
// eslint-disable-next-line prefer-const
backendHost = process.env.REACT_APP_BACKEND_HOST || 'http://localhost:63529'; // suppose set to prod api

export const apiBase = `${backendHost}`;
